// Required for MFE and sharing dependencies.
// (see https://celum.atlassian.net/wiki/spaces/PROC/pages/2035482638/MFE+gotchas+and+good+to+know+s#Error%3A-Shared-module-is-not-available-for-eager-consumption)
import('./bootstrap');
